import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { MessageSquare, PackageSearch, RotateCcw, ShieldCheck } from "lucide-react";

const TILES = [
  { icon: PackageSearch, title: "Track my order", desc: "Enter your order number and email to see live status.", to: "/track" },
  { icon: RotateCcw, title: "Return an item", desc: "30-day risk-free returns. Free US return shipping.", to: "/refund-policy" },
  { icon: ShieldCheck, title: "Warranty claim", desc: "2-year manufacturer warranty on every product.", to: "/contact" },
  { icon: MessageSquare, title: "Talk to a human", desc: "Real support, fast replies. 9am–6pm CT Mon–Fri.", to: "/contact" },
];

export default function Support() {
  return (
    <div className="fade-in" data-testid="page-support">
      <SEO title="Support" description="Help center for CreatorMic Pro." path="/support" />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-8">
        <p className="eyebrow mb-4">Support</p>
        <h1 className="text-h1 text-[#1D1D1F]">Get help fast.</h1>
        <p className="mt-4 text-[#86868B] max-w-xl">Most questions have quick answers. Pick a topic below or reach out directly — real humans, real fast.</p>
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-10 py-12 grid sm:grid-cols-2 gap-4">
        {TILES.map((t) => (
          <Link key={t.title} to={t.to} className="soft-card p-8 flex items-start gap-4" data-testid={`support-${t.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <t.icon size={28} strokeWidth={1.5} className="text-[#0066FF]" />
            <div>
              <p className="font-display text-lg font-bold text-[#1D1D1F]">{t.title}</p>
              <p className="text-sm text-[#86868B] mt-1">{t.desc}</p>
            </div>
          </Link>
        ))}
      </section>
      <section className="max-w-6xl mx-auto px-6 md:px-10 py-16 text-center">
        <h2 className="text-h2">Still stuck?</h2>
        <p className="text-[#86868B] mt-3">Email <a className="text-[#0066FF]" href="mailto:support@creatormicpro.com">support@creatormicpro.com</a> or use the <Link className="text-[#0066FF]" to="/contact">contact form</Link>.</p>
      </section>
    </div>
  );
}
